<template>
  <span :title="timezone">
    {{ adjustedDatetime }}
  </span>
</template>
<script>
import { computed } from "vue";
import { DateTime } from "luxon";
import { useStore } from "vuex";

export default {
  name: "TimezoneDisplay",
  props: {
    datetime: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const store = useStore();

    // Vuexからタイムゾーンとオフセットを取得
    const offset = computed(() => store.state.zoneinfo);
    const timezone = computed(() => store.state.timezone);

    // タイムゾーン適用後の日時を計算
    const adjustedDatetime = computed(() => {
      return DateTime.fromISO(props.datetime)
        .setZone(`UTC${offset.value >= 0 ? "+" : ""}${offset.value}`)
        .toLocaleString({
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
    });

    return {
      adjustedDatetime,
      timezone,
    };
  },
};
</script>
